import { render, staticRenderFns } from "./FooterEditor.vue?vue&type=template&id=33e3782c"
import script from "./FooterEditor.vue?vue&type=script&lang=js"
export * from "./FooterEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports